import { compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getCurrentUser } from '@mews-commander/core';
import { getCurrentEnterpriseSubscriptionCode } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { moduleSelector } from './module';

export const isSalesForceLoaded = compose(get('isSalesForceLoaded'), moduleSelector);

export const isSalesForceInitialized = compose(get('isSalesForceInitialized'), moduleSelector);

export const isOpened = compose(get('isOpened'), moduleSelector);

export const getUserSalesForceConfiguration = createSelector(
    getCurrentEnterpriseSubscriptionCode,
    () => getCurrentUser(),
    (subscriptionCode, { id: userId, firstName, lastName, email }) => ({
        extraPrechatFormDetails: [
            {
                label: 'Mews User Id',
                value: userId,
                displayToAgent: true,
                transcriptFields: ['MewsUserId__c'],
            },
            {
                label: 'Account Number',
                value: subscriptionCode,
                displayToAgent: true,
                transcriptFields: ['AccountNumber__c'],
            },
            {
                label: 'First Name',
                displayToAgent: true,
                transcriptFields: ['First_Name__c'],
            },
            {
                label: 'Last Name',
                displayToAgent: true,
                transcriptFields: ['Last_Name__c'],
            },
            {
                label: 'Email',
                displayToAgent: true,
                transcriptFields: ['Email__c'],
            },
        ],
        extraPrechatInfo: [
            {
                entityFieldMaps: [
                    {
                        fieldName: 'LastName',
                        label: 'Last Name',
                        doCreate: false,
                        doFind: false,
                        isExactMatch: true,
                    },
                    {
                        fieldName: 'FirstName',
                        label: 'First Name',
                        doCreate: false,
                        doFind: false,
                        isExactMatch: true,
                    },
                    {
                        fieldName: 'Email',
                        label: 'Email',
                        doCreate: false,
                        doFind: false,
                        isExactMatch: true,
                    },
                    {
                        fieldName: 'Mews_User_Id__c',
                        label: 'Mews User Id',
                        doCreate: true,
                        doFind: true,
                        isExactMatch: true,
                    },
                ],
                entityName: 'Contact',
            },
        ],
        prepopulatedPrechatFields: {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Subject: '',
        },
    })
);
